import React, { Component } from "react";
import "./Progress.css";

class Progress extends Component {
	render() {
		return (
			<div className="onboarding-progress">
			<p className="progress-num">{this.props.onboardingStep + 1} of {Object.keys(this.props.onboardingFlow).length}</p>
			<h2 className="mb-20">{this.props.onboardingFlow[this.props.onboardingStep]}</h2>
			</div>
		);
	}
}

export default Progress;


// WEBPACK FOOTER //
// ./src/components/SignUp/Progress/Progress.js